import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import classnames from "classnames";
const ConfirmPresentationOpen: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { confirmOpenDocument, cancelOpenDocument, presentationName } =
    rootStore.guestStore;
    const { isMobileMediaQuery } = rootStore.responsiveStore;
  const [t] = useTranslation(["guest"], translationHookOptions);

  return (
    <>
      <div className="modal-content mt-5">
        <div className="modal-header bg-dark text-white justify-content-center">
          <h5 className="modal-title">{t("uploaded_doc")}</h5>
        </div>
        <div className="modal-body">
          <div className="presentation-title-container">
            <h5 className="presentation-title">{presentationName}</h5>
          </div>
        </div>
        <div className="modal-footer">
          <Row className="w-100">
          <Col md={6} className={classnames("d-flex  mb-4", !isMobileMediaQuery ?"justify-content-center" :"justify-content-end")}>
            {/* <Col md={6} className="d-flex justify-content-center mb-4"> */}
              <Button
                className= {classnames("bg-dark text-white",!isMobileMediaQuery ? "w-75" : "")}
                // className="bg-dark text-white w-75"
                onClick={cancelOpenDocument}
              >
                {t("cancel")}
              </Button>
            </Col>
            <Col md={6} className={classnames("d-flex  mb-4", !isMobileMediaQuery? "justify-content-center": "")}>
            {/* <Col md={6} className="d-flex justify-content-center mb-4"> */}
              <Button
                className= {classnames("bg-dark text-white",!isMobileMediaQuery ? "w-75" : "")}
                onClick={() =>{confirmOpenDocument()}}
              >
                {t("continue")}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default observer(ConfirmPresentationOpen);
